import { Card, CardBody } from "@components/ui/Card"
import { ClassroomCard } from "@features/classrooms"
import { ArrowRight } from "lucide-react"
import { memo } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import type { Classroom } from "@/types"

interface Props {
  classrooms: Classroom[]
  totalClassrooms: number
}

export const HomeClassroomsPreview = memo(function HomeClassroomsPreview({
  classrooms,
  totalClassrooms,
}: Props) {
  const { t } = useTranslation("home")
  const showFooter = totalClassrooms > classrooms.length

  if (classrooms.length === 0) {
    return null
  }

  return (
    <Card>
      <CardBody className="space-y-3">
        <h2 className="text-ink text-sm font-semibold">{t("classrooms.title")}</h2>
        {/* `grid-cols-1` is load-bearing, not decorative: a grid with no
            explicit template sizes its implicit track to the items'
            min-content, and `ClassroomCard`'s title is `truncate`
            (`white-space: nowrap`), so its min-content is the whole
            untruncated name. A long subject — "Pensamiento Matemático VI:
            Pensamiento estadístico y probabilístico 2°C" from the SEP
            catalog — grew the track to 751px inside a 322px column and the
            cards spilled out of the panel. Tailwind's numeric `grid-cols-*`
            compiles to `repeat(n, minmax(0, 1fr))`; that `0` floor is what
            lets the track shrink and the title actually truncate. */}
        <div className="grid grid-cols-1 gap-3">
          {classrooms.map((c) => (
            <ClassroomCard key={c.id} classroom={c} />
          ))}
        </div>
        {showFooter && (
          <Link
            to="/salones"
            className="text-accent-ink inline-flex items-center gap-1 text-sm font-medium hover:underline"
          >
            {t("classrooms.view_all", { count: totalClassrooms })}{" "}
            <ArrowRight className="h-3 w-3" />
          </Link>
        )}
      </CardBody>
    </Card>
  )
})
